module.exports = __webpack_public_path__ + "img/bancor.d83ecb2d.png";